import { UserDefinedMaintenancePage } from "@/components/specific/userDefined";
import { UserDefinedItemType } from "@/types/domain";

export const ProductUserDefinedMaintenancePage = () => {
  return (
    <UserDefinedMaintenancePage
      itemType={UserDefinedItemType.Product}
      entityType="UserDefProduct"
      title="Product User Defined Items"
      cacheKey="product_user_defined_sort"
    />
  );
};
